export enum EnvironmentEnum {
    prod = 'prod',
    preprod = 'preprod',
    develop = 'develop',
}
